/*
 * @Date: 2022-08-29 10:55:13
 * @LastEditors: kinfai
 * @Description: 聊天列表
 * @LastEditTime: 2022-08-31 11:00:00
 * @FilePath: \my-app\src\pages\ChatConversation\components\ChatContent\index.jsx
 */
import './index.less'
import {Image, Spin} from 'antd';
import {useState, useRef, useEffect, useImperativeHandle, forwardRef} from "react";
import MsgTypeCollection from "../MsgType";

// import useCs from "../../../../hooks/cs/index.js";
const awaiter = (sepeed = 1) => new Promise(resolve => setTimeout(() => resolve(), 1 * 1000))

function ChatContent(props = {
    msgList: [],
    canLoading: true,
    queryMessage: () => {
    },
    addTextMsg: () => {
    }
}, ref) {
    const {msgList} = props
    // const {getCsId} = useCs()

    const {
        FormMsg,
        RobotMsg,
        MeMsg,
        TransferMsg,
        LevelMsg,
        LevelMsgInfo
    } = MsgTypeCollection

    const [userStatus, setUserStatus] = useState(false)

    const contentRef = useRef(null)
    const scrollToBottom = (scrollHeight = 100) => {
        const dom = document.querySelector('.g-chat-msg-list')
        if (dom) {
            const height = dom.scrollHeight / 100 * scrollHeight
            dom.scrollTo(0, height)
        }
    };

    // const uniRobot = msgList.find(item => item.type === 'robot')
    // if (!uniRobot) {
    // msgList.unshift({
    //     id: 15151,
    //     type: "robot"
    // })
    // }

    // mock - user状态
    // useEffect(() => {
    //     setTimeout(() => setUserStatus(true), 1000)
    //
    //     return () => setTimeout(() => setUserStatus(false), 3000)
    // }, [])

    useImperativeHandle(ref, () => ({scrollToBottom}))

    // 滚动加载
    const [loading, updateLoading] = useState(false)
    const handleScroll = async () => {
        const scrollTop = document.querySelector('.g-chat-msg-list').scrollTop
        if (scrollTop === 0 && !loading && props.canLoading) {
            updateLoading(true)
            await props.queryMessage()
            await awaiter(1)
            updateLoading(false)
        }
    }

    return <div
        className='g-chat-msg-list'
        ref={contentRef}
        onScroll={handleScroll}
    >
        <div style={{
            alignItems: 'center',
            justifyContent: "center",
            height: "50px",
            display: loading === true ? 'flex' : 'none'
        }}>
            <Spin/>
        </div>
        {
            msgList.filter(item => item).map(msg => {
                const {id, type, text} = msg
                // robot - msg
                if (type === 'robot') {
                    return <RobotMsg key={id} text={text} addTextMsg={props.addTextMsg}/>
                }

                // transfer - msg
                if (type === 'transfer') {
                    return <div key={id} style={{margin: '17px 0'}}>
                        <TransferMsg name={msg.name}/>
                    </div>
                }

                // text - msg
                if (type === 'text') {
                    const {value, isMe, isRead} = msg;
                    const UserMsg = isMe ? MeMsg : FormMsg;

                    const read = isRead ? ' read' : ''
                    const me = isMe ? ' me' : ''
                    const cls = `g-chat-msg-container${me}${read}`

                    return <div key={msg.id} className={cls}>
                        <UserMsg value={value}/>
                    </div>
                }

                // img - msg
                if (type === 'img') {
                    const {value, isMe} = msg

                    return <div
                        key={id}
                        className='g-chat-me-img'
                        style={{textAlign: isMe ? 'right' : 'left'}}>
                        <Image width={86} src={value}/>
                    </div>
                }

                // levelMsg
                if (type === 'levelMsg') {
                    return <LevelMsg key={id} tip={msg.value}/>
                }

                // levelMsgInfo
                if (type === 'levelMsgInfo') {
                    return <LevelMsgInfo key={id} value={msg.value}/>
                }

                return <p key={id}>无法显示</p>
            })
        }
        {
            userStatus && <div className='s-user-status'>...LuLucai is typing</div>
        }
    </div>
}

export default forwardRef(ChatContent);
